module.exports = __webpack_public_path__ + "img/icon_kehuduan@2x.035aabff.png";